import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { ForgotTranslations } from "./components/Forgot/Forgot.i18n.tsx";
import { LoginTranslations } from "./components/Login/Login.i18n.tsx";
import { OtpPasswordTranslations } from "./components/OtpPassword/OtpPassword.i18n.tsx";
import { OtpRegisterTranslations } from "./components/OtpRegister/OtpRegister.i18n.tsx";
import { PasswordResetTranslations } from "./components/PasswordReset/PasswordReset.i18n.tsx";
import { RegisterTranslations } from "./components/Register/Register.i18n.tsx";
import { TermsTranslations } from "./components/Terms/Terms.i18n.tsx";
import { ProfileTranslations } from "./components/Profile/Profile.i18n.tsx";
import { ProjectDetailsTranslations } from "./components/ProjectDetails/ProjectDetails.i18n.tsx";
import { ProjectsTranslations } from "./components/Projects/Projects.i18n.tsx";
import { SidebarTranslations } from "./components/SideBar/SideBar.i18n.tsx";
import { SettingsTranslations } from "./components/Settings/Settings.i18n.tsx";
import { LogoutModalTranslations } from "./modals/LogoutModal/LogoutModal.i18n.tsx";
import { ChangePasswordModalTranslations } from "./modals/ChangePasswordModal/ChangePasswordModal.i18n.tsx";
import { CustomDisclaimerModalTranslations } from "./modals/CustomDisclaimerModal/CustomDisclaimerModal.i18n.tsx";
import { DeleteProjectModalTranslations } from "./modals/DeleteProjectModal/DeleteProjectModal.i18n.tsx";
import { NewProjectModalTranslations } from "./modals/NewProject/NewProjectModal.i18n.tsx";
import { ProjectDetailsModalOptionsTranslations } from "./modals/ProjectDetailsOptions/ProjectDetailsOptions.i18n.tsx";
import { OtpPasswordModalTranslations } from "./modals/OtpPasswordModal/OtpPasswordModal.i18n.tsx";
import { StandardProjectModalTranslations } from "./modals/StandardProjectModal/StandardProjectModal.i18n.tsx";
import { CustomProjectModalTranslations } from "./modals/CustomProjectModal/CustomProjectModal.i18n.tsx";
import { NoSelectedProjectTranslations } from "./components/NoSelectedProject/NoSelectedProject.i18n.tsx";
import { NoProjectTranslations } from "./components/NoProject/NoProject.i18n.tsx";
import { UnitsTranslations } from "./context/Theme.i18n.tsx";
import { CatalogAdminTranslations } from "./components/CatalogAdmin/CatalogAdmin.i18n.tsx";

const modules = [
  ForgotTranslations,
  LoginTranslations,
  OtpPasswordTranslations,
  OtpRegisterTranslations,
  PasswordResetTranslations,
  RegisterTranslations,
  TermsTranslations,
  ProfileTranslations,
  ProjectDetailsTranslations,
  ProjectsTranslations,
  SidebarTranslations,
  SettingsTranslations,
  LogoutModalTranslations,
  ChangePasswordModalTranslations,
  CustomDisclaimerModalTranslations,
  DeleteProjectModalTranslations,
  NewProjectModalTranslations,
  ProjectDetailsModalOptionsTranslations,
  OtpPasswordModalTranslations,
  StandardProjectModalTranslations,
  CustomProjectModalTranslations,
  NoSelectedProjectTranslations,
  NoProjectTranslations,
  UnitsTranslations,
  CatalogAdminTranslations,
];

const buildTranslations = (lang: "en" | "es") =>
  modules.reduce(
    (acc, module) => ({
      ...acc,
      ...module[lang],
    }),
    {}
  );

export const resources = {
  en: { translation: buildTranslations("en") },
  es: { translation: buildTranslations("es") },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en-US",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
